

const str={
    name:"str",
    type:"string",
    description:"String to sanitize",
},whitelist={
    name:"whitelist",
    type:"string",
    description:"Characters to keep in addition to letters, numbers and spaces",
}

export default {
    id:"sanitize",
    type:"function",
    description:"string that only contains numbers, letters and spaces along with the whitelisted characters",
    overloads:[
        {
            type:"(str:string,whitelist?:string):String",
            props:[str,whitelist],
        },
        {
            type:"(str:string,escape?:boolean,whitelist?:string):String",
            props:[
                str,
                {
                    name:"escape",
                    type:"boolean",
                    description:"if true, certain characters will be replaced by a hexadecimal escape sequence",
                },
                {
                    ...whitelist,
                    description:`
                        if escape true, represents the characters to skip escaping, skips spaces by default
                        @if escape false, this overload behaves the same as the first overload
                    `,
                },
            ],
        },
    ],
}
